import { render, staticRenderFns } from "./ClientUpdate.vue?vue&type=template&id=6666055e&scoped=true&"
import script from "./ClientUpdate.vue?vue&type=script&lang=js&"
export * from "./ClientUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ClientUpdate.vue?vue&type=style&index=0&id=6666055e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666055e",
  null
  
)

export default component.exports